import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Link, TextCallout2 } from 'blocket-ui'
import { mediaQueries, withDevice } from '@blazar-plugins/device'
import IconFordon from './icons/IconFordon'
import IconPersonligt from './icons/IconPersonligt'
import IconResor from './icons/IconResor'
import IconAffarsverksamhet from './icons/IconAffarsverksamhet'
import IconElektronik from './icons/IconElektronik'
import IconForHemmet from './icons/IconForHemmet'
import IconFritidHobby from './icons/IconFritidHobby'
import IconJobb from './icons/IconJobb'
import IconUtbildning from './icons/IconUtbildning'
import IconBostad from './icons/IconBostad'
import IconOvrigt from './icons/IconOvrigt'
import IconAllCategories from './icons/IconAllCategories'
import NewBadge from './NewBadge'

const Wrapper = styled.div`
  @media ${mediaQueries.medium} {
    padding-top: 12px;
  }

  li {
    display: inline-block;
    margin: 0 8px;

    &:last-of-type {
      margin-right: 0;
    }

    &:first-of-type {
      margin-left: 0;
    }
  }

  @media ${mediaQueries.large} {
    ul {
      display: flex;
      justify-content: space-between;
      padding-bottom: 8px;
    }
  }
`

export const StyledLink = styled(Link)`
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #363433;
`

const LinkText = styled(TextCallout2)`
  font-size: 12px;
  color: #696766;
  max-width: 74px;
  text-overflow: ellipsis;
  overflow: hidden;

  @media ${mediaQueries.large} {
    font-size: 15px;
    max-width: unset;
    text-overflow: unset;
    overflow: unset;
  }
`

const StyledIconWrapper = styled.div`
  position: relative;
  /* Accomodates outline, without it the svg clips the outline. */
  margin: ${({ isStartPage }) => (isStartPage ? '1px 1px 6px 1px' : '1px 1px 4px 1px')};
  background: ${({ isStartPage }) => (isStartPage ? '#fff' : '#f9f7f6')};
  border-radius: 50%;
  padding: 2px;
  height: 56px;
  ${({ isStartPage }) => isStartPage && `box-shadow: 0 1px 0 0 rgba(0, 0, 0, 0.25);`}

  &:hover {
    transform: scale(1.05);
  }
  &:active {
    transform: scale(0.95);
  }
`

export const Icon = ({ type }) => {
  switch (type) {
    case 'fordon':
      return <IconFordon />
    case 'personligt':
      return <IconPersonligt />
    case 'resor':
      return <IconResor />
    case 'affarsverksamhet':
      return <IconAffarsverksamhet />
    case 'elektronik':
      return <IconElektronik />
    case 'forhemmet':
      return <IconForHemmet />
    case 'fritid':
      return <IconFritidHobby />
    case 'jobb':
      return <IconJobb />
    case 'utbildning':
      return <IconUtbildning />
    case 'bostad':
      return <IconBostad />
    case 'ovrigt':
      return <IconOvrigt />
    case 'kategorier':
      return <IconAllCategories />
    default:
      return <IconFordon />
  }
}

Icon.propTypes = {
  type: PropTypes.string.isRequired,
}

export const FirstLevel = ({
  items = [],
  trackQuickAssCategoryClick,
  external,
  device,
  isStartPage,
}) => (
  <Wrapper>
    <ul>
      {items.map(({ link, type, label, showNewBadge }) => {
        return (
          <li key={link}>
            <StyledLink
              external={external}
              to={link}
              onClick={(e) => {
                if (trackQuickAssCategoryClick) {
                  trackQuickAssCategoryClick(e, label)
                }
              }}
            >
              <StyledIconWrapper isStartPage={isStartPage}>
                <Icon type={type} />
                {showNewBadge && <NewBadge />}
              </StyledIconWrapper>
              <LinkText>{label}</LinkText>
            </StyledLink>
          </li>
        )
      })}
      {!device.is('medium') && (
        <li key="kategorier">
          <StyledLink
            external={external}
            to="/kategorier"
            onClick={(e) => {
              if (trackQuickAssCategoryClick) {
                trackQuickAssCategoryClick(e, 'kategorier')
              }
            }}
          >
            <StyledIconWrapper isStartPage={isStartPage}>
              <Icon type="kategorier" />
            </StyledIconWrapper>
            <LinkText>Alla kategorier</LinkText>
          </StyledLink>
        </li>
      )}
    </ul>
  </Wrapper>
)

FirstLevel.propTypes = {
  items: PropTypes.array,
  trackQuickAssCategoryClick: PropTypes.func,
  external: PropTypes.bool,
  device: PropTypes.object.isRequired,
  isStartPage: PropTypes.bool,
}

export default withDevice(FirstLevel)
